import { api } from '@/lib/api';

const unwrap = (p) => p.then((r) => r.data);

/** Monitoraggio indicatori CETS (Admin). */
export const cetsService = {
  overview: (period) => unwrap(api.get('/admin/cets/overview', { params: period ? { period } : {} })),
  history: (freq = 'year', n = 6) => unwrap(api.get('/admin/cets/history', { params: { freq, n } })),
  saveMeasurement: (payload) => unwrap(api.post('/admin/cets/measurements', payload)),
  setIndicator: (code, payload) => unwrap(api.put(`/admin/cets/indicators/${code}`, payload)),
  exportCsv: (period) => api.get('/admin/cets/export', { params: period ? { period } : {}, responseType: 'blob' }),
  responses: (tenant) => unwrap(api.get('/admin/cets/responses', { params: tenant ? { tenant } : {} })),
  responsesExportCsv: (tenant) => api.get('/admin/cets/responses/export', { params: tenant ? { tenant } : {}, responseType: 'blob' }),
  // Visibilità pubblica del badge CETS per stakeholder (gating admin)
  setVisibility: (ownerId, enabled) => unwrap(api.post(`/admin/cets/stakeholders/${ownerId}/visibility`, { enabled })),
  // Gestione domande del questionario CETS (autovalutazione)
  listQuestions: () => unwrap(api.get('/admin/cets/questions')),
  addQuestion: (body) => unwrap(api.post('/admin/cets/questions', body)),
  deleteQuestion: (id) => unwrap(api.delete(`/admin/cets/questions/${id}`)),
};

/** Questionario CETS per stakeholder + rating pubblico (vetrina). */
export const cetsSelfService = {
  getSelf: () => unwrap(api.get('/cets/self')),
  saveSelf: (answers) => unwrap(api.put('/cets/self', { answers })),
  publicRating: (ownerId) => unwrap(api.get(`/public/cets/rating/${ownerId}`)),
  publicRatings: (ownerIds) => unwrap(api.post('/public/cets/ratings', { owner_ids: ownerIds })),
};

export default cetsService;
